/**
 * @desc 平台账期相关-关闭账期
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/platformAccountPeriod/closePeriod/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
